import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../environments/environment.prod";

@Injectable()
export class UserService {
  private readonly LAST_CHECK_KEY = 'last_user_status_check';
  private readonly CHECK_INTERVAL = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
  private readonly API_URL = environment.apiUrl;

  constructor(private http: HttpClient) { }

  shouldCheckUserStatus(): boolean {
    const lastCheck = localStorage.getItem(this.LAST_CHECK_KEY);
    if (!lastCheck) return true;

    const lastCheckTime = parseInt(lastCheck, 10);
    const currentTime = Date.now();

    return (currentTime - lastCheckTime) > this.CHECK_INTERVAL;
  }

  updateLastCheckTime(): void {
    localStorage.setItem(this.LAST_CHECK_KEY, Date.now().toString());
  }

  checkUserStatus(username: string): Observable<boolean> {
    return this.http.get<boolean>(this.API_URL + `/api/logins/status/${username}`);
  }

  // Optional: Get current user from localStorage
  getCurrentUser(): any {
    const userStr = localStorage.getItem('Agroinformer-Current-User');
    return userStr ? JSON.parse(userStr) : null;
  }

  // Optional: Get username from current user
  getCurrentUsername(): string | null {
    const user = this.getCurrentUser();
    return user?.username || null;
  }

  isUserAgroModerator(): boolean {
    const user = this.getCurrentUser();
    return user?.mod_agro ? true : false;
  }

  isUserAgroAdmin(): boolean {
    const user = this.getCurrentUser();
    return user?.owner_agro ? true : false;
  }

  isUserTransportModerator(): boolean {
    const user = this.getCurrentUser();
    return user?.mod_transport ? true : false;
  }

  isUserTransportAdmin(): boolean {
    const user = this.getCurrentUser();
    return user?.owner_transport ? true : false;
  }
}